module.exports = __webpack_public_path__ + "img/icon-show-group.d8cd6751.svg";